<h2>Health Over Time</h2>
<p> {{totalIntegrations()}} Integrations Ran</p>
<div class="line-chart-container">
    <canvas
        baseChart
        [data]="lineChartData()"
        [type]="lineChartType"
        [options]="lineChartOptions()"
      ></canvas>
</div>
